import { API_BASE_URL, TOKEN_TYPE } from '@/config';
import axios from 'axios';
import store from '@/store';
import AuthService from '@/services/AuthService';

const IS_PROD = true;
var axios_ = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  post(context, url, data = {}, options, gateway = false) {
    return new Promise(async (resolve, reject) => {
      let token = store.getters.user ? store.getters.user.access_token : '';
      if (!AuthService.checkExpiredToken(token)) {
        await AuthService.refreshToken(context);
      }
      let API_URL = IS_PROD ? store.getters.API_URL : store.getters.API_URL;
      data['fleet_id'] = data['fleet_id']
        ? data['fleet_id']
        : store.state && store.state.fleet && store.state.fleet.selected_fleet
        ? store.state.fleet.selected_fleet['value']
        : '';
      token = store.getters.user ? store.getters.user.access_token : '';
      axios_.defaults.headers.common['Authorization'] = TOKEN_TYPE + ' ' + token;
      const langHeader = store.getters.lang ? store.getters.lang : 'tr';
      axios_.defaults.headers['Language-Preference'] = langHeader;
      axios_
        .post(API_URL + url, data, options)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(async error => {
          if (error.response.status === 401) {
            await AuthService.logout(context);
          }
          reject(error);
        });
    });
  },
  get(url, params = {}) {
    return new Promise(async (resolve, reject) => {
      let token = store.getters.user ? store.getters.user.access_token : '';
      // let API_URL = IS_PROD ? store.getters.API_URL : store.getters.API_URL
      let API_URL = IS_PROD ? store.getters.API_URL : store.getters.API_URL;
      params['fleet_id'] = params['fleet_id']
        ? params['fleet_id']
        : store.state.fleet && store.state.fleet.selected_fleet
        ? store.state.fleet.selected_fleet['value']
        : '';
      const publicPages = ['get_directions_road_google'];
      const authRequired = publicPages.map(p => !url.includes(p)).includes(true);

      if (authRequired && !AuthService.checkExpiredToken(token)) {
        await AuthService.refreshToken();
      }
      token = store.getters.user ? store.getters.user.access_token : '';
      axios_.defaults.headers.common['Authorization'] = TOKEN_TYPE + ' ' + token;
      const langHeader = store.getters.lang ? store.getters.lang : 'tr';
      axios_.defaults.headers['Language-Preference'] = langHeader;
      axios_
        .get(API_URL + url, { params: params })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          console.log('error', error);
          reject(error);
        });
    });
  },
  delete(url, data, gateway = false) {
    return new Promise(async (resolve, reject) => {
      let token = store.getters.user ? store.getters.user.access_token : '';
      let API_URL = IS_PROD ? store.getters.API_URL : store.getters.API_URL;
      if (!AuthService.checkExpiredToken(token)) {
        await AuthService.refreshToken();
      }
      token = store.getters.user ? store.getters.user.access_token : '';
      axios_.defaults.headers.common['Authorization'] = TOKEN_TYPE + ' ' + token;
      const langHeader = store.getters.lang ? store.getters.lang : 'tr';
      axios_.defaults.headers['Language-Preference'] = langHeader;
      axios_
        .delete(API_URL + url, { data: data })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  put(context, url, data, options, gateway = false) {
    return new Promise(async (resolve, reject) => {
      let token = store.getters.user ? store.getters.user.access_token : '';
      let API_URL = IS_PROD ? store.getters.API_URL : store.getters.API_URL;
      data['fleet_id'] =
        store.state && store.state.fleet && store.state.fleet.selected_fleet
          ? store.state.fleet.selected_fleet['value']
          : '';
      if (!AuthService.checkExpiredToken(token)) {
        await AuthService.refreshToken(context);
      }
      data['fleet_id'] =
        store.state.fleet && store.state.fleet.selected_fleet ? store.state.fleet.selected_fleet['value'] : '';
      token = store.getters.user ? store.getters.user.access_token : '';
      axios_.defaults.headers.common['Authorization'] = TOKEN_TYPE + ' ' + token;
      const langHeader = store.getters.lang ? store.getters.lang : 'tr';
      axios_.defaults.headers['Language-Preference'] = langHeader;
      axios_
        .put(API_URL + url, data, options)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};
